var lastWidth = 0; lastHeight = 0;
var intevalCheckInfineOptionsLoaded, loopCheckInfineOptionsLoaded = 0, maxLoopCheckInfineOptionsLoaded = 50;
var currentMobileMenuClick;
var currencyMobile;
var scrollTop, lastScrollTop, scrollbarWidth, scrollDirection;
var announcementHeight, headerHeight;

$(function()
{
  // POPIN GB
  $(".popup-alert-add-to-cart .close").click(function(e){
    e.preventDefault();
    $(".popup-alert-add-to-cart").removeClass('open');
    createCookie('popup-alert-add-to-cart', '1', 1); // 1h
  });
  
  // SIZE CHART
  $(".open-size-chart, .accordion-content-sizing a[title='Size guide'], .accordion-content-sizing a[title='size chart']").click(function(e){
    e.preventDefault();
    wetheme.toggleRightDrawer("sizechart");
  });
  
  // NAV
  $(".change-menu-mobile-n2").click(function(e){
    e.preventDefault();
    $(".change-menu-mobile-n2").removeClass('active');
    $(this).addClass('active');
    var handle = $(this).data('handle');
    $(".mobile-nav-n2").addClass('hide');
    $(".mobile-nav-n2[data-handle='"+handle+"']").removeClass('hide');
  });
  
  $(".mobile-search-call").click(function(e){
    e.preventDefault();
    wetheme.toggleRightDrawer("search",!0);
  });
  
  $(".mobile-nav > .mobile-nav__item > .mobile-nav__has-sublist > a.mobile-nav__link").click(function(e){
    e.preventDefault();
    
    currentMobileMenuClick = $(this).parent().next(".mobile-nav__sublist");
    
    $(".mobile-nav > li.mobile-nav__item > .mobile-nav__sublist:visible").each(function(){
      if ($(this) != currentMobileMenuClick) $(this).toggle(250);
    });
    
    if (!$(this).parent().next(".mobile-nav__sublist").is(":visible"))
      $(this).parent().next(".mobile-nav__sublist").toggle(250);
  });
  
  $(".mobile-menu--close-btn").click(function(e){
    e.preventDefault();
    $("body").removeClass("js-drawer-open js-drawer-open-left");
  });
  
  $('a.open-sub-nav').click(function(e){
    e.preventDefault();
    if ($(this).parent().find('.site-nav__sub').is('.open')) {
      $('.site-nav .site-nav__sub').removeClass('open');
    } else {
	  $('.site-nav .site-nav__sub').removeClass('open');
  	  $(this).parent().find('.site-nav__sub').addClass('open');
    }
  });
  
  // PRODUCTS
  if ($("#productSelect-template--product").length || $("#productSelect-template--product-pre-order").length || $("#productSelect-template--product-wholesale").length || $("#productSelect-template--product-madetomeasure").length)
  {
    /*$(".swatch-element.color").click(function(){
      var color = slugify($(this).data("value"));
      $("a.product-medias__thumbnail").addClass("hide");
      $("a.product-medias__thumbnail[data-variant-color='"+color+"']").removeClass("hide");
    });*/
    
    $(".color-selector .links").find('a').sort(function (a, b) {
      var aVal = String($(a).attr('title'));
      var bVal = String($(b).attr('title'));
      return bVal < aVal ? 1 : -1
    }).appendTo('.color-selector .links');
    
    if ($('#infiniteoptions-container').length) {
      intevalCheckInfineOptionsLoaded = setInterval(CheckInfineOptionsLoaded, 250);
    }

    $(".selector-wrapper-grid-size a.change-size").click(function(e){
      e.preventDefault();
      
      $('.selector-wrapper-grid-size a.change-size').removeClass("selected");
      $(this).addClass("selected");

      var variant = $(this).data('variant');
      $("#AddToCartForm .wetheme-dropdown__wrapper ul li[data-variant='" + variant + "']").click();
    });

    $("#AddToCartForm .wetheme-dropdown__wrapper ul li").click(function(){
      var soldout = $(this).data('soldout');

      if ($(this).is('.change-size')) {
        $('.selector-wrapper-grid-size a.change-size').removeClass("selected");
        $(this).addClass("selected");
        $("#productSelect-template--product option[value='" + $(this).data('variant') + "']").prop("selected", true);
      }
      
      /*$('#AddToCart').removeClass('pre-order');
      $('#AddToCart .add-to-cart-label-classic').text('Add to Cart');
      $('#AddToCart .add-to-cart-label-sold-out').text('Sold out');
      $('.pre-order-alert').addClass('hide');*/
      
      if (soldout != 1) {
        var url = window.location.href;
        var tmp = url.split('variant=');
        var variant = tmp[1];
        
        if ($('.pre-order-alert[data-variant-id="'+variant+'"]').length > 0) {
          $('#AddToCart').addClass('pre-order');
          $('#AddToCart .add-to-cart-label-classic').text('pre order');
	      $('.pre-order-alert[data-variant-id="'+variant+'"]').removeClass('hide');
        }

        //$('.paymentButtonsWrapper').show();
        //$('.soldout-text').hide();
        $('.klaviyo-bis-trigger').hide();
      } else {
        //$('.paymentButtonsWrapper').hide();
        //$('.soldout-text').show();
        $('.klaviyo-bis-trigger').show();
        
        /*variant_id = $('select[name="id"] option:selected').val();
        console.log(variant_id, '#klaviyo-bis-iframe #variants option[value="'+variant_id+'"]');
        $('#klaviyo-bis-iframe #variants option[value="'+variant_id+'"]').prop("selected", true);*/
      }
    });
    
    if ($("#AddToCartForm .wetheme-dropdown__wrapper ul li.selected").data('soldout') != 1) {
      var variant = $('.pre-order-alert:not(.hide)').data('variant-id');

      if ($('.pre-order-alert[data-variant-id="'+variant+'"]').length > 0) {
        $('#AddToCart').addClass('pre-order');
        $('#AddToCart .add-to-cart-label-classic').text('pre order');
        $('.pre-order-alert[data-variant-id="'+variant+'"]').removeClass('hide');
      }
    }
  }
  
  $("#AddToCartMultiple").click(function(e){
    e.preventDefault();
    
    $("#AddToCartMultiple").addClass('wait');
    $("#AddToCartMultiple .add").addClass('hide');
    $("#AddToCartMultiple .added").addClass('hide');
    $("#AddToCartMultiple .adding").removeClass('hide');

    var items = [];
    $("#AddToCartAllQuantity .item").each(function(i){
      q = $("#quantity-" + i).val();
      if (q > 0) items.push({quantity: q, id: $("#variant-" + i).val()});
    });

    $.ajax({
      type: "POST",
      url: '/cart/add.json',
      data: { items: items },
      dataType: 'application/json',
      //success: AddToCartMultipleSuccess,
      //error: AddToCartMultipleError,
      complete: AddToCartMultipleComplete
    });
  });
  
  function AddToCartMultipleSuccess(s) {

  }
  function AddToCartMultipleError(s){

  }
  function AddToCartMultipleComplete(s){
    $.ajax({
      url: '/cart.js',
      dataType: 'json'
    })
    .done(function(data){
      $('.cart-item-count-header').text(data.item_count);
      
      $('#AddToCartAllQuantity .item > div input').val(0);
      
      $("#AddToCartMultiple .add").addClass('hide');
      $("#AddToCartMultiple .adding").addClass('hide');
      $("#AddToCartMultiple .added").removeClass('hide');
      
      setTimeout(function(){
        $("#AddToCartMultiple").removeClass('wait');
        $("#AddToCartMultiple .added").addClass('hide');
        $("#AddToCartMultiple .adding").addClass('hide');
        $("#AddToCartMultiple .add").removeClass('hide');
      }, 2000);
    });
    
    //window.location.href = "/cart?showSuccess=true";
  }
  
  // MADE TO MEASURE
  if ($('#made-to-measure').length > 0) {
    $('#made-to-measure .product-medias__thumbnail').click(function(e){
      var style = $(this).find('.product-media-label').data('label');
      $('#made-to-measure .product-medias__thumbnail').removeClass('active');
      $(this).addClass('active');
      $('#infiniteoptions-container div[aria-labelledby="STYLE-0-0"] input[value="'+style+'"]').click();
      $('h2.made-to-measure-style').text(style);
    });
  }
  
  // COLLECTIONS
  $('.open-sidebar-filter.show-me').click(function(e){
    e.preventDefault();
    $('.page-collection-sidebar-filter__sidebar').addClass('open');

    $('.open-sidebar-filter.hide-me, a.reset-filter').show();
    $('.open-sidebar-filter.show-me').hide();
    
    if (lastWidth <= 768) $('body').addClass('js-drawer-open');
  });
  $('.open-sidebar-filter.hide-me').click(function(e){
    e.preventDefault();
    $('.page-collection-sidebar-filter__sidebar').removeClass('open');

    $('.open-sidebar-filter.hide-me, a.reset-filter').hide();
    $('.open-sidebar-filter.show-me').show();
    
    if (lastWidth <= 768) $('body').addClass('js-drawer-open');
  });
  $('.reset-filter').click(function(e){
    e.preventDefault();
    $('.filter-collection').removeClass('on');
    $('.open-sidebar-filter.hide-me').click();
	RunFilterCollection();
  });
  $('.apply-filter').click(function(e){
    e.preventDefault();
    $('.open-sidebar-filter.hide-me').click();
    RunFilterCollection();
  });
  $('.page-collection-sidebar-filter__sidebar > .close').click(function(e){
    e.preventDefault();
    $('.page-collection-sidebar-filter__sidebar').removeClass('open');
    
    if (lastWidth <= 768) $('body').removeClass('js-drawer-open');
  });
  $('#DrawerOverlay').click(function(e){
    if ($('.page-collection-sidebar-filter__sidebar').is('.open'))
      $('.page-collection-sidebar-filter__sidebar').removeClass('open');
  });
  
  if ($('.collection-sidebar-filter').length)
  {
    $('a.open-filters').click(function(e){
      e.preventDefault();
      
      $(this).toggleClass('open');
      $('.collection-sidebar-filter .sub-filter').toggle(250);
    });
    
    var aCollectionColors = unescape(collection_colors).replace('+', ' ');
    var aCollectionColorsGroups = unescape(collection_colors_groups).replace('+', ' ');
    var aCollectionSizes = unescape(collection_sizes).replace('+', ' ');

    aCollectionColors = String(aCollectionColors.substring(1, aCollectionColors.length-1)).split('][');
    $.each(aCollectionColors,function(key,value){
      var data = value.split('#|#');
      var c = data[0].split('-');
      if (data[0] != '') $("#filter-colors").append('<a href="#" class="filter-collection filter-collection-unique filter-color" data-filter="'+data[0]+'" title="'+data[0]+'"><span style="background-color:'+c[0]+';background-image:url('+data[3]+');"></span></a>');
    });
    
    $('#filter-colors-groups a').hide();
    aCollectionColorsGroups = String(aCollectionColorsGroups.substring(1, aCollectionColorsGroups.length-1)).split('][');
    $.each(aCollectionColorsGroups,function(key,value){
      var c = value;
      $('#filter-colors-groups a[data-filter="'+c+'"]').show();
    });

    aCollectionSizes = String(aCollectionSizes.substring(1, aCollectionSizes.length-1)).split('][');
    $.each(aCollectionSizes,function(key,value){
      var data = value.split('#|#');
      if (data[0] != 'default-title') $("#filter-sizes").append('<a href="#" class="filter-collection filter-collection-unique filter-size" data-filter="'+data[0]+'">'+data[1]+'</a>');
    });
    
    $('#filter-sizes').find('a').sort(function (a, b) {
      var aVal = Number($(a).text());
      var bVal = Number($(b).text());
      return aVal - bVal;
    }).appendTo('#filter-sizes');

    $('a.filter-collection-multiple').click(function(e){
      e.preventDefault();
      
      $(this).toggleClass('on');
      RunFilterCollection();
    });
    
    $('a.filter-collection-unique').click(function(e){
      e.preventDefault();

      if ($(this).is('.on')) {
        $(this).parent().find('.filter-collection').removeClass('on');
      } else {
        $(this).parent().find('.filter-collection').removeClass('on');
        $(this).addClass('on');
      }
      RunFilterCollection();
    });
  }
  
  // TIMER
	if ($(".countdown").length > 0) {
		updateCountDown();
		setInterval(updateCountDown, 500);
	}
	function updateCountDown(now, time) {
		var now = new Date().getTime();
		$(".countdown").each(function(i){
			var s = String($(this).data("date"));
			var t = s.split(/[/ :]/);
			var dt = new Date(t[2], t[1]-1, t[0], t[3], t[4], t[5]);
			var time = new Date(dt).getTime();
			
			var diff, d, h, m, s;

			diff = time - now;
			d = Math.floor(diff / (1000 * 60 * 60 * 24));
			h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
			s = Math.floor((diff % (1000 * 60)) / 1000);
          	
            if (d < 0) d = 0;
            if (h < 0) h = 0;
            if (m < 0) m = 0;
            if (s < 0) s = 0;

			$(this).find(".d .value").text((d<10?'0'+d:d));
			if (d > 1) $(this).find(".d .label .ss").show();
			else $(this).find(".d .label .ss").hide();

			$(this).find(".h .value").text((h<10?'0'+h:h));
			if (h > 1) $(this).find(".h .label .ss").show();
			else $(this).find(".h .label .ss").hide();

			$(this).find(".m .value").text((m<10?'0'+m:m));
			if (m > 1) $(this).find(".m .label .ss").show();
			else $(this).find(".m .label .ss").hide();

			$(this).find(".s .value").text((s<10?'0'+s:s));
			if (s > 1) $(this).find(".s .label .ss").show();
			else $(this).find(".s .label .ss").hide();
			
			$(this).find(".countdown-v2").html(getCountDownText(now, time));
		});
	}
	function getCountDownText(now, time) {
		var diff, d, h, m, s;

		diff = time - now;
		d = Math.floor(diff / (1000 * 60 * 60 * 24));
		h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
		s = Math.floor((diff % (1000 * 60)) / 1000);
      
        //return(d + " jour" + (d>1?'s':'') + " " + (h<10?'0'+h:h) + ":" + (m<10?'0'+m:m) + ":" + (s<10?'0'+s:s));
		var sReturn = '';
		if (d > 0) sReturn += d + " jour"+(d>1?"s ":" ");
		if (h > 0) sReturn += (h<10?'0'+h:h) + " h ";
		if (m > 0) sReturn += (m<10?'0'+m:m) + " min ";
		if (s > 0) sReturn += (s<10?'0'+s:s) + " sec ";

		return(sReturn);
	}
  
  // CART
  $(".send-draft-order").click(function(e){
    e.preventDefault();
    
    $.ajax({
      url: '/cart.js',
      dataType: 'json'
    })
    .done(function(data){
      var email = $('#contact_email').val();
      var website = 'https://jacques-soloviere.myshopify.com';
      
      var sHtml = '';
	  /*sHtml += '<p><strong>NOUVELLE PR&Eacute;-COMMANDE RETAILER</strong><br><br><strong>Email</strong> : '+email+'<br><strong>Nombre d\'articles</strong> : ' + data.item_count + '<br><strong>Montant total</strong> : ' + (data.items_subtotal_price / 100) + '&nbsp;' + data.currency + '</p>';
	  sHtml += '<table width="100%" border="0" cellpadding="10" cellspacing="0"><tr><td width="25%" style="border-bottom: 1px solid #ccc;">&nbsp;</td><td width="50%"  style="border-bottom: 1px solid #ccc;"><strong>Produit</strong></td><td width="25%" style="border-bottom: 1px solid #ccc;"><strong>Montant</strong></td></tr>';
      
      for (var i=0; i<data.items.length; i++) {
        var item = data.items[i];
        sHtml += '<tr><td valign="top" style="border-bottom: 1px solid #ccc;"><a href="'+website+item.url+'" target="_blank"><img src="'+item.image+'" width="180"></a></td><td valign="top" style="border-bottom: 1px solid #ccc;"><a href="'+website+item.url+'" target="_blank">'+item.product_title+'</a><br>';
        for (var j=0; j<item.options_with_values.length; j++) {
          var option = item.options_with_values[j];
          sHtml += (j > 0 ? '<br>' : '') + option.name + ' : ' + option.value;
        }
        sHtml += '</td><td valign="top" style="border-bottom: 1px solid #ccc;">'+item.quantity+'&nbsp;x&nbsp;'+(item.final_price / 100)+' '+data.currency+'<br><strong>'+(item.final_line_price / 100)+' '+data.currency+'</strong></td></tr>';
      }
  
      sHtml += '</table>';*/
      
      sHtml += 'NOUVELLE COMMANDE RETAILER' + '\r\n' + '<br>';
      sHtml += '——————————————————————————————' + '\r\n' + '<br>';
      sHtml += 'Email : ' + email + '\r\n' + '<br>';
      sHtml += 'Nombre d\'articles : ' + data.item_count + '\r\n' + '<br>';
      sHtml += 'Montant total : ' + (data.items_subtotal_price / 100) + ' ' + data.currency + '\r\n' + '<br>';
      
      for (var i=0; i<data.items.length; i++) {
        var item = data.items[i];
        sHtml += '——————————————————————————————' + '\r\n' + '<br>';
        sHtml += 'URL : ' + website + item.url + '\r\n' + '<br>';
        sHtml += 'TITRE : ' + item.product_title + '\r\n' + '<br>';
        for (var j=0; j<item.options_with_values.length; j++) {
          var option = item.options_with_values[j];
          sHtml += '- ' + option.name + ' : ' + option.value + '\r\n' + '<br>';
        }
        sHtml += 'MONTANT : ' + item.quantity +' x ' + (item.final_price / 100) + ' = ' + (item.final_line_price / 100) + ' '+ data.currency + '\r\n' + '<br>';
      }
      
      $('#contact_message').val(sHtml);
	  $('#contact_form').submit();
    });
  });
  
  $('.retailer-form-open').click(function(e){
    e.preventDefault();
    $('.retailer-form').removeClass('hide');
    $('html, body').animate({scrollTop: $("#retailer-form-target").offset().top}, 1000);
  });
  
  // CustomerLoginForm
  if ($("#CustomerLoginForm").length) {
    var url = window.location.href;
    if (url.indexOf('?checkout_url=') != -1) {
      var url_part = url.split('?checkout_url=');
      $("#input_checkout_url").val(url_part[1]);
    }
  }
  
  // Switch currency
  $(".ultimate-currency-call").click(function(e){
    e.preventDefault();
    var target = $(this).parent().find('.ultimate-currency');
    if (target.find('.currencyDropWrapperContainer').length == 0) {
      target.find('#launch-btn-widget').click();
      setTimeout(AddBtnCurrencyCmd, 250);
    }
  });
  
  $(".ultimate-currency-set").click(function(e){
    e.preventDefault();
    currencyMobile = $(this).data('currency');
    
    $(".ultimate-currency-call").click();
    
    setTimeout(function(){
      if (currencyMobile == 'EUR') $(".ultimate-currency .cb-currency-item:eq(0)").click();
      else if (currencyMobile == 'USD') $(".ultimate-currency .cb-currency-item:eq(1)").click();
    }, 500);
  });
  function AddBtnCurrencyCmd() {
    $(".ultimate-currency .cb-currency-item:not(.ready)").click(function(e){
      var currency = String(String($(this).find('div').text()).split('(')[1]).replace(')', '');
      $(".ultimate-currency-call").text(currency);
    }).addClass('ready');
  }
  
  // Loop test currency
  var currencyTestIntervalLoopIndex = 0;
  var currencyTestIntervalLoopMax = 20;
  var currencyTestInterval = setInterval(function(){
    if ($('.ultimate-currency > div').length > 0) {
      clearInterval(currencyTestInterval);
      $(".ultimate-currency-call").text(String($('.money.conversion-bear-money:eq(0)').text()).substring(0, 1));
      $(".menu-currency").removeClass('hide');
    }
    
    currencyTestIntervalLoopIndex++;
    if (currencyTestIntervalLoopIndex >= currencyTestIntervalLoopMax)
      clearInterval(currencyTestInterval);
  }, 500);

  // REPAIR
  var $formRepair = $('form#repair_form'), url = 'https://script.google.com/macros/s/AKfycbwO6SiGswDjLpMpUFtSRliwkxFO6L4wqSU0lBA_QrpjCs1yd7Q8y-9BiOsnMbl4pkNy/exec';
  $('#repair_form').on('submit', function(e) {
    e.preventDefault();

    $('#repair_form').addClass('loading');
    
    var jqxhr = $.ajax({
      crossDomain: true,
      url: url,
      method: "GET",
      dataType: "json",
      data: $formRepair.serializeObject()
    })
    .done(function(e) {
      if (e.result == 'error') {
        $('#repair_form').addClass('fail');
      } else {
        $('#repair_form').addClass('done');
      }
      
      $('#repair_form').removeClass('loading');
    })
    .fail(function(e) {
      $('#repair_form').addClass('fail');
      $('#repair_form').removeClass('loading');
    });
  });

  // RETURN
  var $formReturn = $('form#return_form'), url = 'https://script.google.com/macros/s/AKfycbwO6SiGswDjLpMpUFtSRliwkxFO6L4wqSU0lBA_QrpjCs1yd7Q8y-9BiOsnMbl4pkNy/exec';
  $('#return_form').on('submit', function(e) {
    e.preventDefault();

    $('#return_form').addClass('loading');
    
    var jqxhr = $.ajax({
      crossDomain: true,
      url: url,
      method: "GET",
      dataType: "json",
      data: $formReturn.serializeObject()
    })
    .done(function(e) {
      if (e.result == 'error') {
        $('#return_form').addClass('fail');
      } else {
        $('#return_form').addClass('done');
      }
      
      $('#return_form').removeClass('loading');
    })
    .fail(function(e) {
      $('#return_form').addClass('fail');
      $('#return_form').removeClass('loading');
    });
  });
  
  InitScripts();
  InitResize();
  InitScroll();
  InitSearchV2();
});

function CheckInfineOptionsLoaded() {
  loopCheckInfineOptionsLoaded++;
  
  if (loopCheckInfineOptionsLoaded >= maxLoopCheckInfineOptionsLoaded)
  {
    clearInterval(intevalCheckInfineOptionsLoaded);
  }
  else if ($('#infiniteoptions-container .checkbox-add-perso').length)
  {
    clearInterval(intevalCheckInfineOptionsLoaded);
    
    $('#infiniteoptions-container input[type="checkbox"]').each(function(){
      var label = $(this).parent().text();
      $(this).parent().html('<div class="pretty p-switch p-fill"><input type="checkbox" value="' + label + '" class="spb-productoptiontextcolor spb-productoptionbackground"><div class="state"><label>' + label + '</label></div></div>');
    });
    
    $('#infiniteoptions-container .radio-add-color > span > label').each(function(){
      var col = slugify($(this).text());
      $(this).append('<span class="color ' + col + '" data-color="' + col + '"></span>');
    });
    
    if ($('#made-to-measure').length > 0)
      RunInfiniteOptionsMadeToMeasure();
    
    $('#infiniteoptions-container').attr('data-ready', 'ready');
  }
}

function InitScripts() {
  // OWL SLIDER
  $('.homepage-sections-wrapper .js-slider').owlCarousel({
    dots: false, loop: true, margin: 8, nav: true, navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    responsive: {
      0: {items:1, margin:20},
      600:{items:2},
      1000:{items:3}
    }
  });
  
  $('.product-recommendations .js-slider').owlCarousel({
    dots: false, loop: true, margin: 8, nav: true, navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    responsive: {
      0: {items:2, margin:20},
      600:{items:3},
      1000:{items:4}
    }
  });
  
  // RATIO
  $(".js-ratio").each(function(i){
    var r = String($(this).attr("data-ratio")).split(":");
    $(this).attr("data-ratio", (r[1]/r[0]));

    if ($(this).attr("data-ratio-mobile")) {
      r = String($(this).attr("data-ratio-mobile")).split(":");
      $(this).attr("data-ratio-mobile", (r[1]/r[0]));
    } else {
      $(this).attr("data-ratio-mobile", $(this).attr("data-ratio"));
    }
  });
  
  // PRODUCTS
  if ($("#productSelect-template--product").length || $("#productSelect-template--product-pre-order").length)
  {
    $("#AddToCartForm .wetheme-dropdown select option").each(function(i){
      var val = $(this).val();
      var soldout = $(this).is('.sold-out');
      var variant = $(this).data('variant');

      $("#AddToCartForm .wetheme-dropdown__wrapper ul li[value='"+val+"']").attr('data-variant', variant);
      
      if (soldout)
        $("#AddToCartForm .wetheme-dropdown__wrapper ul li[value='"+val+"']").attr('data-soldout', '1');
    });

    /*$('.selector-wrapper-grid-size a.change-size').click(function(e){
      e.preventDefault();
      $('.selector-wrapper-grid-size a.change-size').removeClass("selected");
      $(this).addClass("selected");
      $("#productSelect-template--product option[value='" + $(this).data('variant') + "']").prop("selected", true);
    });*/

    if ($("#AddToCartForm .wetheme-dropdown__wrapper ul li.selected").data('soldout') != 1)
      $('.klaviyo-bis-trigger').hide();
    else
      $('.klaviyo-bis-trigger').show();
  }

  // ACCORDIONS
  $('.accordion:not(.ready)').each(function(e) {
    var accordion = $(this);
    var toggleSpeed = accordion.attr('data-speed') || 100;

    $(this).addClass('ready');

    function open(item, speed) {
      accordion.find('.accordion-item').not(item).removeClass('active').find('.accordion-content').slideUp(speed);
      item.addClass('active').find('.accordion-content').slideDown(speed);
    }
    function close(item, speed) {
      item.removeClass('active').find('.accordion-content').slideUp(speed);
    }

    open(accordion.find('.active:first'), 0);

    accordion.on('click', '.accordion-title', function(ev) {
      ev.preventDefault();
      
      if ($(this).closest('.accordion-item').is('.active')) {
        close($(this).closest('.accordion-item'), toggleSpeed);
      } else {
        open($(this).closest('.accordion-item'), toggleSpeed);
      }
    });
  });
}

function RunFilterCollection()
{
  var search = '';
  
  if ($('a.filter-collection.on').length)
  {
    var searchTag = '', searchColor = '', searchColorGroup = '', searchSize = '', searchVariant = '', searchFinal = '';
    
    $('a.filter-collection.on').each(function(){
	  if ($(this).is('.filter-tag')) searchTag = $(this).data('filter');
      else if ($(this).is('.filter-color')) searchColor = $(this).data('filter');
      else if ($(this).is('.filter-color-groups')) searchColorGroup = $(this).data('filter');
      else if ($(this).is('.filter-size')) searchSize = $(this).data('filter');
    });
    
    if ($('#filter-colors-groups').length == 0) {
      if (searchColor != '' && searchSize != '') searchVariant = '[' + searchColor + '#|#' + searchSize + ']';
      else if (searchColor != '') searchVariant = '[' + searchColor + '#|#';
      else if (searchSize != '') searchVariant = '#|#' + searchSize + ']';
    } else {
      if (searchColorGroup != '' && searchSize != '') searchVariant = '[' + searchColorGroup + '#|#' + searchSize + ']';
      else if (searchColorGroup != '') searchVariant = '[' + searchColorGroup + '#|#';
      else if (searchSize != '') searchVariant = '#|#' + searchSize + ']';
    }
    
    if (searchTag != '') searchFinal += '[data-tags*="['+searchTag+']"]';
    if (searchVariant != '') searchFinal += '[data-variants*="'+searchVariant+'"]';
    
    $('.collection-main-body-inner .grid__item').hide();
    $('.collection-main-body-inner .grid__item' + searchFinal).show();
  }
  else
  {
    $('.collection-main-body-inner .grid__item').show();
  }
  
  //$('html, body').animate({scrollTop: 0}, 0);
  
  //$('.page-collection-sidebar-filter__sidebar').removeClass('open');
  if (lastWidth <= 768) $('body').removeClass('js-drawer-open');
}

// RESIZE
function InitResize()
{
  $(window).resize(function(){ Resize(); });
  document.addEventListener("webkitfullscreenchange",function(){ Resize(); }, false);
  window.onorientationchange = function(){ var orientation = window.orientation; Resize(); }
  Resize();
  setTimeout(function(){ Resize(); }, 500);
}
function Resize()
{
  lastWidth = $(window).width();
  lastHeight = $(window).height();

  // Ratio
  $(".js-ratio").each(function(i){
    if (lastWidth < 768) $(this).height(Math.ceil($(this).width() * $(this).attr("data-ratio-mobile")));
    else $(this).height(Math.ceil($(this).width() * $(this).attr("data-ratio")));
  });
  
  // NAV
  announcementHeight = $("#shopify-section-announcement-bar").height();
  headerHeight = $("header.site-header").height();

  CheckLoadingVideos();
}

// SCROLL
function InitScroll()
{
  $(window).scroll(function(){
    scrollTop = $(window).scrollTop();

    /*if (scrollTop > lastScrollTop) scrollDirection = 1;
    else scrollDirection = -1;

    if (!searchOpen) {
      if (scrollDirection == 1) {
        if (scrollTop > (announcementHeight + headerHeight)) {
          $('#shopify-section-header').addClass('fixed');
          $('#main').addClass('decal');
          if (!$('#shopify-section-header').is('.anim')) {
            $('#shopify-section-header').addClass('anim').stop().animate({'top':-headerHeight}, 250, function(){
              $(this).removeClass('anim');
            });
          }
        } else {
          $('#shopify-section-header').removeClass('fixed');
          $('#main').removeClass('decal');
          $('#shopify-section-header').stop().animate({'top':-headerHeight}, 0);
        }
      } else {
        if (scrollTop < announcementHeight) {
          $('#shopify-section-header').removeClass('fixed');
          $('#main').removeClass('decal');
        } else {
          $('#shopify-section-header').addClass('fixed');
          $('#main').addClass('decal');
          if (!$('#shopify-section-header').is('.anim')) {
            $('#shopify-section-header').addClass('anim').stop().animate({'top':0}, 250, function(){
              $(this).removeClass('anim');
            });
          }
        }
      }
    }*/

    if ($('body').is('.template-index')) {
      if (scrollTop > 150 && !$('.text-10-ans').is('.out')) {
        $('.text-10-ans').addClass('out');
      } else if (scrollTop < 150 && $('.text-10-ans').is('.out')) {
        $('.text-10-ans').removeClass('out');
      }
      
      if (scrollTop > 150 && !$('.header-section').is('.scrolled')) {
        $('.header-section').addClass('scrolled');
      } else if (scrollTop < 150 && $('.header-section').is('.scrolled')) {
        $('.header-section').removeClass('scrolled');
      }
    } else if ($('.section-top10ans').length > 0) {
      if (scrollTop > 150 && !$('.section-top10ans').is('.out')) {
        $('.section-top10ans').addClass('out');
      } else if (scrollTop < 150 && $('.section-top10ans').is('.out')) {
        $('.section-top10ans').removeClass('out');
      }
    }

    CheckLoadingVideos();

    lastScrollTop = scrollTop;
  });
  $(window).scroll();
}

// SEARCH V2
var searchOpen = false;
var searchReady = false;

function InitSearchV2()
{
  $('.search-button-v2').click(function(e){
    e.preventDefault();
    
    if (!$('#search-v2').is(':visible')) {
      $("html").addClass('no-scroll search-open');
      $("#search-v2").show();
      $('#search-v2 input[type="search"]').focus();

      searchOpen = true;
      setTimeout(function(){
        searchReady = true;
      }, 100);
    }
  });
  
  $('#search-v2 .close').click(function(e){
    e.preventDefault();
    $("html").removeClass('no-scroll search-open');
    $("#search-v2").hide();
    
    searchOpen = false;
    searchReady = false;
  });
  
  var searchTimeoutThrottle = 500;
  var searchTimeoutID = -1;
  var currReqObj = null;
  var $resultsBox = $('#search-v2 .results');
  
  $('#search-v2:not(.auto-open) input[type="search"]').bind('keyup change', function(){
    if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
      $(this).data('oldval', $(this).val());

      if(currReqObj != null) currReqObj.abort();

      clearTimeout(searchTimeoutID);

      var $form = $(this).closest('form');
	  var term = '*' + $form.find('input[name="q"]').val() + '*';
      var linkURL = $form.attr('action') + '?q=' + term;

      $resultsBox.html('<div class="load"></div>');
      $resultsBox.css({'display': 'flex'});

      searchTimeoutID = setTimeout(function(){
        currReqObj = $.ajax({
          url: $form.attr('action'),
          data: {
            type: 'product',
            view: 'json',
            q: term,
          },
          dataType: "json",
          success: function(data){
            currReqObj = null;
            if(data.results_total == 0) {
              $resultsBox.html('<div class="note">No result</div>');
            } else {
              $resultsBox.empty();
              $.each(data.results, function(index, item){
                var $row = $('<a class="link n'+(index+1)+'"></a>').attr('href', item.url);
                $row.append('<div class="img"><img src="' + item.image + '" /></div>');
                $row.append('<div class="d-title">'+item.title+'</div>');
                $resultsBox.append($row);
              });
              $resultsBox.append('<a href="' + linkURL + '" class="note">View all results</a>');
            }
          }
        });
      }, searchTimeoutThrottle);
    } else if ($(this).val().length <= 2) {
      $resultsBox.empty();
    }
  }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
    //$resultsBox.fadeIn(200);
  }).bind('click', function(e){
    e.stopPropagation();
  });
  
  $('body').bind('click', function(){
    if (searchReady) {
      $('#search-v2 .close').click();
    }
    //$resultsBox.fadeOut(200);
  });

  //Search box should mimic live search string: products only, partial match
  $('#search-v2-form').on('submit', function(e){
    e.preventDefault();
    var term = '*' + $(this).find('input[name="q"]').val() + '*';
    var linkURL = $(this).attr('action') + '?q=' + term;
    window.location = linkURL;
  });
}

// SLUG
function slugify(s) {
  return  s.toString().toLowerCase()
	.replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')       // Special Characters #1
	.replace(/[èÈéÉêÊëË]+/g, 'e')       	// Special Characters #2
	.replace(/[ìÌíÍîÎïÏ]+/g, 'i')       	// Special Characters #3
	.replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')       	// Special Characters #4
	.replace(/[ùÙúÚûÛüÜ]+/g, 'u')       	// Special Characters #5
	.replace(/[ýÝÿŸ]+/g, 'y')       		// Special Characters #6
	.replace(/[ñÑ]+/g, 'n')       			// Special Characters #7
	.replace(/[çÇ]+/g, 'c')       			// Special Characters #8
	.replace(/[ß]+/g, 'ss')       			// Special Characters #9
	.replace(/[Ææ]+/g, 'ae')       			// Special Characters #10
	.replace(/[Øøœ]+/g, 'oe')       		// Special Characters #11
	.replace(/[%]+/g, 'pct')       			// Special Characters #12
	.replace(/\s+/g, '-')           		// Replace spaces with -
    .replace(/[^\w\-]+/g, '')       		// Remove all non-word chars
    .replace(/\-\-+/g, '-')         		// Replace multiple - with single -
    .replace(/^-+/, '')             		// Trim - from start of text
    .replace(/-+$/, '');            		// Trim - from end of text
}

// POPUP GB
function testPopupAddToCartGB(){
  /*if (locISO == 'GB') {
    var testPopupAlertAddToCart = readCookie('popup-alert-add-to-cart');
    if (!testPopupAlertAddToCart) {
      $(".popup-alert-add-to-cart").addClass('open');
    }
  }*/
}
  
// COOKIE
function createCookie(a,b,c){var d="";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d="; expires="+e.toGMTString()}document.cookie=a+"="+b+d+"; path=/"}function readCookie(a){for(var b,c=a+"=",d=document.cookie.split(";"),e=0;e<d.length;e++){for(b=d[e];" "==b.charAt(0);)b=b.substring(1,b.length);if(0==b.indexOf(c))return b.substring(c.length,b.length)}return null}function eraseCookie(a){createCookie(a,"",-1)}

// HERO VIDEO
function CheckLoadingVideos() {
  $('.video-hero-wrapper, .homepage-section--video-wrapper').each(function(i){
    $(this).find("video").each(function(j){
      var yVideo1 = ($(this).offset().top - scrollTop - lastHeight);
      var yVideo2 = yVideo1 + $(this).height() + lastHeight;
      if (yVideo1 < 50 && yVideo2 > -50) {
        if ($(this).is(".toload") && $(this).is(":visible")) {
          $(this).removeClass("toload").attr("src", $(this).attr("data-src"));
        }
        if (!$(this).is(".toload") && !$(this).is(":visible")) {
          $(this).addClass("toload").attr("src", "");
        }
      }
    });
  });
}